import { TenderGridLayout } from "../TenderGridLayout";
import { Button, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLoadTenderExpress extends Layout {
    buttonAccept: Button;
    buttonDecline: Button;
    buttonExclude: Button;
    buttonFilter: Button;
    buttonRefresh: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    labelLastRefresh: Label;
    labelLastRefreshDateTime: Label;
    layoutAll: TenderGridLayout;
    layoutCancel: TenderGridLayout;
    layoutChange: TenderGridLayout;
    layoutOriginal: TenderGridLayout;
    layoutheaderLTX: LayoutHeader;
    ltxProfileTextbox: Textbox;
    panelLastRefresh: Panel;
    sourceEdiStop: DataSource;
    sourceLoadTenderExpressRemote: DataSource;
    switchRefresh: Switch;
    tabAll: Tab;
    tabCancel: Tab;
    tabChange: Tab;
    tabOriginal: Tab;
    tabsetTenderExpress: Tabset;
}
